import {_get} from "@api/services/httpService";

export const OPTION_URI = "/clubs/playgrounds/options"

export const getClubOptions = (clubId) => _get(OPTION_URI +'?club.id=' + clubId + '&itemsPerPage=120');
